export const QA_NAME_MATCH_CRITERIA_POPOVER = 'matchCriteriaPopover'

export const QA_NAME_MATCH_CRITERIA_POPOVER_TRIGGER = 'matchCriteriaPopoverOpen'

export const MATCH_CRITERIA_POPOVER_OFFSET = 8

export const MATCH_CRITERIA_POPOVER_SHEET_MAX_WIDTH = 848

export const MATCH_CRITERIA_POPOVER_COLUMN_TITLE_KEYS = [
  'RentalPortal.MatchColumnCriterionKey',
  'RentalPortal.MatchColumnRequirementKey',
  'RentalPortal.MatchColumnApplicantKey',
  'RentalPortal.MatchColumnFitKey',
]
